import { withStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';
import React from 'react';
import { withRouter } from 'react-router-dom';

import { Alert } from '_components/elements';
import { CompleteCreditCardForm } from '_components/forms';

/* */
import { createValidationSchema, validators } from '_utils/validation';

/* */
const validationSchema = createValidationSchema({
  cvv: validators.cvv,
  dueDate: validators.dateFourDigits,
});

/* */
const styles = (theme) => ({
  paper: {
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px`,
  },
  panel: {
    alignItems: 'center',
    flexDirection: 'column',
  },
  radio: {
    padding: 0,
    marginRight: theme.spacing.unit * 2,
  },
  marginT: {
    marginTop: theme.spacing.unit * 2,
  },
});

/* */
class RecurringPayment extends React.Component {
  /* */
  static defaultProps = {
    currency: 'EUR',
  };

  /* */
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };

    this.form = React.createRef();
  }

  /* */
  getCardInfos = () => this.form.current.getExtraInfos();

  /* */
  onFormSubmit = (values, actions) => {
    const { onSubmit } = this.props;

    const newValues = {
      ...values,
      ...this.getCardInfos(),
      id3D: null,
    };

    onSubmit(newValues, actions);
  };

  /* */
  renderCardForm() {
    const { error } = this.state;

    const submitText = 'Enregistrer';
    // Ne pas annoncer de montant : la forme du contrôle monétaire est décidée par
    // le serveur, golf par golf (autorisation de 1 € ou demande d'information à
    // 0 €). Un montant écrit ici serait faux dès la bascule d'un golf.
    const submitHintText = `Dans le cadre de la réglementation DSP2, votre banque
      procédera à une vérification de votre carte, sans débit.`;

    return (
      <React.Fragment>
        {error && <Alert variant='error'>{error}</Alert>}
        <Formik
          initialValues={{
            cvv: '',
            number: '',
            dueDate: '',
          }}
          validateOnBlur={false}
          validateOnChange={false}
          onSubmit={this.onFormSubmit}
          validationSchema={validationSchema}
        >
          {(props) => (
            <CompleteCreditCardForm
              {...props}
              innerRef={this.form}
              imprintUse='required'
              submitButtonText={submitText}
              submitButtonHintText={submitHintText}
            />
          )}
        </Formik>
      </React.Fragment>
    );
  }

  /* */
  render() {
    const { currency } = this.props;

    // Seule la devise EUR est acceptée
    if (currency !== 'EUR') {
      return (
        <Alert variant='warning'>
          {`Actuellement, la devise ${currency} n'est pas acceptée pour le paiement en ligne.`}
        </Alert>
      );
    }

    // Ce composant est le formulaire de saisie PAN. Il aboutit à `paylineSubscribe`
    // (createToken seul), qui ne crée AUCUN wallet Payline : la carte enregistrée par
    // cette voie n'est pas prélevable, et le filet serveur lui inventait un `wallet_id`
    // inexistant chez Monext (cf. audit du 28/07, chaîne 2). Seule une session Payline
    // (widget) produit un wallet réel. On ne propose donc plus la saisie directe.
    return (
      <Alert variant='error'>
        {'L’enregistrement de carte par saisie directe n’est plus disponible. '
          + 'Utilisez le paiement sécurisé, qui enregistre la carte pour vos prochains règlements.'}
      </Alert>
    );
  }
}

const PaymentWithRouter = withRouter(RecurringPayment);

export default withStyles(styles)(PaymentWithRouter);
